export default "__VITE_ASSET__e251106d__"